import React, { Component } from 'react';
import Accordion from '../../components/accordion';
import strategiesPage from '../../contentful/strategyPage.json';
import H1 from '../../components/h1';
import BackButton from '../../components/back-button';
import safeGa from '../../modules/safeGa';

class StrategiesPage extends Component {
  componentDidMount() {
    safeGa('set', 'page', '/strategies.html');
    safeGa('send', 'pageview');
  }

  render() {
    return (
      <div className={'theme-magenta'}>
        <BackButton />
        <H1>Strategic directions</H1>
        <Accordion
          items={strategiesPage.strategies}
          activeId={this.props.location.hash.replace('#', '')}
        />
      </div>
    );
  }
}
export default StrategiesPage;



// WEBPACK FOOTER //
// ./src/pages/strategies/strategies.js